<template>
  <div class="note-container" @click.prevent.stop="openLink">
    <template v-for="note in notes">
      <b-tabs v-if="note.class === 'Variants'" class="Variants" content-class="mt-3" active-nav-item-class="font-weight-bold" fill>
        <b-tab v-for="variant in note.elements" :title="variant.edition">
          <multi-element v-if="variant.stanza" :element="variant.stanza"/>
          <character v-if="variant.character" :character="variant.character"/>
          <verse v-else-if="variant.verse" :verse="variant.verse"/>
          <p v-else v-html="variant.text"></p>
        </b-tab>
      </b-tabs>
      <div v-else :class="note.class">
        <div class="content" v-html="note.text"></div>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    components: {
      MultiElement: () => import('./MultiElement'),
      Character: () => import('./Character'),
      Verse: () => import('./Verse')
    },
    props: {
      id: {type: Array, required: true}
    },
    computed: {
      notes() {
        return this.id.map(id => this.$store.state.notes[id])
      }
    },
    methods: {
      openLink(event) {
        if (event.target.tagName === 'A') {
          window.open(event.target.href, '_blank')
        }
      }
    }
  }
</script>
<style lang="scss">
  .note-container {
    .Variants .nav-tabs .nav-item {
      margin-bottom: 0;

      .nav-link {
        border: none;
      }
    }

    > *:not(:last-child) {
      margin-bottom: 10px;
    }
  }
</style>
